import {StyleSheet} from 'react-native';
import {Platform} from 'react-native';

import {darkGray, lightGray, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    padding: 4,
    backgroundColor: lightGray,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#ccc',
    marginTop: 30,
    marginBottom: 20,
  },
  streak: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  arrowPlaceholder: {
    width: 44,
    height: 44,
  },
  calendarHeaderText: {
    flex: 1,
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 'bold',
  },
  grid: {
    alignItems: 'center',
  },
  dayBox: {
    width: 26,
    height: 44,
    margin: 2,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#ccc',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  completedBox: {
    borderColor: '#66bb6a',
    backgroundColor: '#e8f5e9',
  },
  redDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: 'red',
    position: 'absolute',
    bottom: 4,
    left: '50%',
    marginLeft: -3,
  },
  dayContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  dayText: {
    marginBottom: 2,
    marginTop: 5,
    fontSize: 12,
  },
  cellContainer: {
    height: 60,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  checkMark: {
    fontSize: Platform.OS === 'android' ? 7 : 8,
    color: 'green',
    textAlign: 'center',
    marginBottom: 4,
  },
  checkMarkWhite: {
    fontSize: Platform.OS === 'android' ? 7 : 8,
    color: white,
    textAlign: 'center',
    marginBottom: 4,
  },
  crossMark: {
    color: darkGray,
    fontSize: 10,
    textAlign: 'center',
    marginBottom: 4,
  },
  crossMarkWhite: {
    color: white,
    fontSize: 10,
    textAlign: 'center',
    marginBottom: 4,
  },
  markPlaceholder: {
    fontSize: 2,
    marginTop: -15,
    color: 'transparent',
  },
  markedDatesContainer: {
    backgroundColor: 'white',
    borderColor: 'green',
    borderWidth: 1,
    borderRadius: 8,
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  markedDatesText: {
    color: '#000',
    fontWeight: 'normal',
  },
  calendarView: {
    backgroundColor: 'transparent',
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
  },
  calendarViewCompleted: {
    backgroundColor: 'white',
    borderColor: 'green', //'#66bb6a',
    borderWidth: 1,
    fontWeight: 'bold',
  },
  calendarViewGrayBox: {
    borderWidth: 1,
    borderColor: '#ccc',
    backgroundColor: '#fff',
  },
  prevNextMonthDate: {
    opacity: 0.5,
  },
  header: {
    padding: 10,
    backgroundColor: '#f7f7f7',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
  },
  selectedDateText: {
    marginTop: 16,
    fontSize: 16,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  todayContainer: {
    backgroundColor: '#006400',
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    width: 32,
    height: 32,
  },
  futureDateContainer: {
    backgroundColor: '#f0f0f0',
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    width: 32,
    height: 32,
  },
  notCompletedContainer: {
    backgroundColor: '#FFF9C4',
    borderColor: '#FBC02D',
    borderWidth: 1,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    width: 32,
    height: 32,
  },
  arrowIcon: {
    width: 30,
    height: 30,
    marginHorizontal: 10,
    color: darkGray,
  },
  goToTodayContainer: {
    marginTop: 12,
    alignItems: 'center',
    marginBottom: 10,
  },
  goToTodayText: {
    color: 'blue',
    fontSize: 14,
    textDecorationLine: 'underline',
    fontWeight: '500',
  },
  calendarLoaderOverlay: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: 10,
  },
});
